import { Injectable } from "@angular/core";
import { UtilsService } from "./utils.service";
import { ToastrService } from "ngx-toastr";
import { ContractService } from "./contract.service";
import { UserService } from "./user.service";
import moment from "moment/moment";

@Injectable({
  providedIn: "root",
})
export class ManageEmployeeContractService {
  public data: any = {
    level: "",
    role: null,
    start_date: null,
    end_date: null,
    trial: "",
    program: "full time",
    contract: null,
    gross_monthly_12: 0,
    net_monthly_12: 0,
    net_monthly_13: 0,
    total_net_monthly_13: 0,
    salary_yearly_gross: 0,
    total_daily: 0,
    bonus: 0,
    production_bonus: 0,
    ticket_card: null,
    ticket_month_number: 0,
    ticket_value: 0,
    ticket_type: "fisso",
    ticket_total: 0,
    tutor_hash: null,
    record_type: "desiderata",
    resignation_url: null,
    closed_at: null,
    closed_reason: null,
  };

  public economic_fields: string[] = ["gross_monthly_12", "net_monthly_12", "net_monthly_13", "total_net_monthly_13", "salary_yearly_gross", "total_daily", "bonus", "production_bonus", "ticket_total"];

  public levels_for_select: any = [];

  private levels_list: any = [];

  public costs: any = [];

  public current_lvl: any;

  public next_lvl: any;

  public tutors: any = [];

  public contractDuration: number = 0;

  public typeIsIndeterminate: boolean = false;

  public typeIsApprendistato: boolean = false;

  public typeIsStage: boolean = false;

  constructor(
    private _utils: UtilsService,
    private _toastService: ToastrService,
    private _contractService: ContractService,
    private _userService: UserService,
  ) { }

  async init(saved_data: any = null) {
    this.costs = await this._contractService.getCosts();
    this.tutors = await this._userService.getList("employee", null, null, "hash, complete_name");
    await this._contractService.getLevels();

    if (saved_data) {
      const data: any = JSON.parse(JSON.stringify(saved_data));

      delete data.resignation_url;
      delete data.file_dimissional;
      delete data.role_name;

      Object.keys(this.data).map((key: string) => {
        if (data.hasOwnProperty(key)) {
          this.data[key] = data[key];
        }
      });

      this.data.salary_yearly_gross = Number(data.salary_yearly_gross);
      this.data.net_monthly_12 = Number(data.net_monthly_12);
      this.data.net_monthly_13 = Number(data.net_monthly_13);
      this.data.total_net_monthly_13 = Number(data.total_net_monthly_13);
      this.data.salary_yearly_gross = Number(data.salary_yearly_gross);
      this.data.total_daily = Number(data.total_daily);
      this.data.bonus = Number(data.bonus);
      this.data.production_bonus = Number(data.production_bonus);
      this.data.company_office_id = Number(data.company_office_id);

      this.data.ticket_total = this.data.ticket_value * this.data.ticket_month_number;

      if (data.role_id) {
        this.data.role = data.role_id;
      }

      if (data.tutor) {
        this.data.tutor_hash = data.tutor.hash;
      }

      const keys: string[] = ["contract", "level", "ticket_type", "ticket_card", "program", "start_date", "end_date", "closed_at", "closed_reason", "role"];
      keys.map((key: string) => {
        if (data[key]) {
          this.data[key] = data[key];
        }
      });

      this.typeIsIndeterminate = data.contract_name === "Indeterminato";
      this.typeIsApprendistato = data.contract_name === "Apprendistato";
      this.typeIsStage = data.contract_name === "Stage";

      if (this.typeIsApprendistato) {
        const start: any = moment(data.start_date);
        const end: any = moment(data.end_date).add(1, "day");
        this.contractDuration = end.diff(start, "months");
        const filteredContracts = this.costs.filter((cost: any) => cost.is_apprendistato === 1 && cost.year == 3).sort((a: any, b: any) => (a.salary_yearly_gross > b.salary_yearly_gross ? 1 : -1));
        filteredContracts.map((cost: any, i: number) => {
          if (cost.level === this.data.level) {
            this.current_lvl = cost;
            if (cost.level !== "B3") {
              this.next_lvl = filteredContracts[i + 1];
            } else {
              this.next_lvl = this.current_lvl;
            }
          }
        });
      } else if (this.typeIsStage) {
        this.current_lvl = {
          level: "",
          role: data.role,
          start_date: null,
          end_date: null,
          trial: "",
          program: "full time",
          contract: data.contract,
          gross_monthly_12: data.gross_monthly_12,
          net_monthly_12: data.net_monthly_12,
          net_monthly_13: data.net_monthly_13,
          total_net_monthly_13: data.total_net_monthly_13,
          salary_yearly_gross: data.salary_yearly_gross,
          total_daily: data.total_daily,
          bonus: 0,
          production_bonus: 0,
          ticket_card: null,
          ticket_month_number: 0,
          ticket_value: 0,
          ticket_type: "fisso",
          ticket_total: 0,
          tutor_hash: null,
        };
      } else {
        if (this.data.level !== "B3") {
          this.current_lvl = this.costs
            .sort((a, b) => {
              return a.salary_yearly_gross > b.salary_yearly_gross ? 1 : -1;
            })
            .find((cost: any, index: number) => {
              if (cost.is_apprendistato === 0 && cost.level === this.data.level) {
                this.next_lvl = this.costs[index + 1];
                return cost;
              }
            });
        } else {
          const b3List: any = this.costs.filter((cost: any) => cost.is_apprendistato === 0 && cost.level === this.data.level);
          this.current_lvl = b3List[0];
          this.next_lvl = b3List[b3List.length - 1];
        }
      }

      if (this.current_lvl) {
        this.current_lvl.total_daily = this.data.total_daily;
      }
      if (this.data.bonus > 0) {
        this.current_lvl.total_daily -= this.data.bonus / 20;
      }

      if (this.data.production_bonus > 0) {
        this.current_lvl.total_daily -= this.data.production_bonus / 12 / 20;
      }

      if (this.data.ticket_value > 0) {
        this.current_lvl.total_daily -= this.data.ticket_value;
      }

      // se la ral, netti e costo giornaliero sono diversi devono andare a sovrascrivere il current_lvl
      this.economic_fields.map((key: string) => {
        if (this.data[key] && this.current_lvl[key] && key !== "total_daily") {
          this.current_lvl[key] = Number(this.current_lvl[key]) !== this.data[key] ? this.data[key] : Number(this.current_lvl[key]);
        }
      });
      this.addDots();

      if (!this.typeIsStage) {
        this.getLevels();
      }
    }
  }

  async changeSalaryGrossYearly(value: any) {
    if (!this.levels_list || this.levels_list.length < 1) {
      this.getLevels();
    }

    const currentLevel: string = this.data.level;

    if (typeof value === "string") {
      value = value.split("");
      if (value[2] === "." && value[value.length - 3] === ".") {
        delete value[2];
      }
      value = value.join("");
      if (value.includes(",")) {
        value = value.replace(",", ".");
      }
      value = Number(value);
    }

    if (!this.data.salary_yearly_gross.includes(".")) {
      this.data.salary_yearly_gross = this._utils.addDotsToNumber(this.data.salary_yearly_gross);
    }

    if (this.typeIsApprendistato) {
      const first: any = this.levels_list[0];
      const last: any = this.levels_list[this.levels_list.length - 1];

      // se la ral inserita è minore/uguale del primo livello impostiamo il primo livello
      if (value <= first.salary_yearly_gross) {
        this.data.level = first.level;
        await this.showPopupEditLevel("UP");
        this.changeLevel(false, false);
      }
      // se la ral inserita è maggiore/uguale dell'ultimo livello impostiamo l'ultimo livello
      else if (value >= last.salary_yearly_gross) {
        this.data.level = last.level;
        await this.showPopupEditLevel("DOWN");
        this.changeLevel(false, false);
      }
      // se la ral inserita è fra il primo e l'ultimo livello ci andiamo a cercare quello che più si avvicina alla ral inserita
      else {
        let currentLvl: any;
        this.levels_list.map(async (cost: any, i: number) => {
          if (!currentLvl && cost.salary_yearly_gross <= value && this.levels_list[i + 1].salary_yearly_gross >= value) {
            this.data.level = cost.level;
            currentLvl = cost;
          }
        });
        this.changeLevel(false, false, false);
        setTimeout(() => this.updateData("ral"));
      }
    } else {
      const costsList: any = !this.typeIsApprendistato ? this.levels_list : this.costs.filter((cost: any) => cost.is_apprendistato === 1 && cost.year === 3);

      const max: any = Number(costsList[costsList.length - 1].salary_yearly_gross);
      const min: any = Number(costsList[0].salary_yearly_gross);

      if (max <= value) {
        this.data.level = this.levels_list[this.levels_list.length - 1].level;
        const listValidLvl: any = this.costs.filter((c: any) => c.level == this.data.level && c.is_apprendistato === 3);
        this.current_lvl = listValidLvl[listValidLvl.length - 1];
        this.data.salary_yearly_gross = this._utils.addDotsToNumber(value);
        this.changeLevel(false, false, false);
        setTimeout(() => this.updateData("ral"));
      } else if (min >= value) {
        this.data.level = this.levels_list[0].level;
        this.changeLevel(false, false, false);
        setTimeout(() => this.updateData());
      } else {
        let founded: boolean = false;
        this.levels_list.map((cost: any, i: number) => {
          if (!founded && Number(cost.salary_yearly_gross) <= value && Number(this.levels_list[i + 1].salary_yearly_gross) >= value) {
            founded = true;
            this.data.level = cost.level;
            this.data.salary_yearly_gross = this._utils.addDotsToNumber(value);
            this.changeLevel(false, false, false);
            setTimeout(() => this.updateData("ral"));
          }
        });
      }
    }

    this.data.level = currentLevel;
  }

  resetData(exclude_role: boolean = false, exclude_date: boolean = false, exclude_ticket: boolean = false) {
    this.data.level = null;
    this.data.trial = null;
    this.data.program = "full time";
    this.data.contract = null;
    this.data.gross_monthly_12 = 0;
    this.data.net_monthly_12 = 0;
    this.data.net_monthly_13 = 0;
    this.data.total_net_monthly_13 = 0;
    this.data.salary_yearly_gross = 0;
    this.data.total_daily = 0;
    this.data.record_type = "desiderata";
    this.data.resignation_url = null;
    this.data.closed_at = null;
    this.data.closed_reason = null;

    if (!exclude_role) {
      this.data.role = null;
    }

    if (!exclude_date) {
      this.data.start_date = null;
      this.data.end_date = null;
    }

    if (!exclude_ticket) {
      this.data.bonus = 0;
      this.data.production_bonus = 0;
      this.data.ticket_card = null;
      this.data.ticket_month_number = 0;
      this.data.ticket_value = 0;
      this.data.ticket_type = "fisso";
      this.data.ticket_total = 0;
    }
  }

  getLevels() {
    const isApprendistato: number = this.typeIsApprendistato ? 1 : 0;
    this.levels_list = this.costs.filter((lvl: any) => lvl.is_apprendistato === isApprendistato);

    if (isApprendistato) {
      this.levels_list = this.levels_list.filter((lvl: any) => lvl.year === 3);
    }

    this.levels_list = this.levels_list.sort((a: any, b: any) => {
      a = parseFloat(a.salary_yearly_gross);
      b = parseFloat(b.salary_yearly_gross);
      return a > b ? 1 : a < b ? -1 : 0;
    });

    this.levels_for_select = [];
    this.levels_list.map((lvl: any) => {
      if (!this.levels_for_select.includes(lvl.level)) {
        this.levels_for_select.push(lvl.level);
      }
    });
  }

  changeContract($event: any) {
    this.resetData(true, true, true);
    this.data.contract = $event.id;

    this.typeIsIndeterminate = $event.name === "Indeterminato";
    this.typeIsApprendistato = $event.name === "Apprendistato";
    this.typeIsStage = $event.name === "Stage";

    if (this.typeIsApprendistato) {
      this.contractDuration = 36;
      if (this.data.start_date && this.data.start_date.length > 0) {
        this.data.end_date = moment(this.data.start_date).add(3, "years").subtract(1, "days").format("YYYY-MM-DD");
      }
    }

    if (!this.typeIsApprendistato && !this.typeIsStage) {
      this.data.tutor_hash = null;
    }

    if (this.typeIsIndeterminate) {
      this.data.end_date = null;
    }

    if (this.typeIsStage) {
      this.levels_for_select = [];
      this.data.net_monthly_12 = "800,00";
      this.data.gross_monthly_12 = "800,00";
      this.data.total_daily = "40,00";
      return false;
    }

    setTimeout(() => this.getLevels());
  }

  changeLevel(fromInput: boolean = false, resetDates: boolean = true, update: boolean = true) {
    this.getLevels();
    const lvlName = this.data.level;
    setTimeout(() => {
      switch (lvlName) {
        case "B3":
          const b3List: any = this.levels_list.filter((c: any) => c.level === lvlName);
          this.current_lvl = b3List[0];
          this.next_lvl = b3List[b3List.length - 1];
          break;
        default:
          this.current_lvl = this.levels_list.find((c: any, index: number) => {
            if (c.level === lvlName) {
              this.next_lvl = this.levels_list[index + 1];
              return c;
            }
          });
          break;
      }

      if (fromInput) {
        this.data.net_monthly_12 = 0;
        this.data.net_monthly_13 = 0;
        this.data.total_daily = 0;
        this.data.salary_yearly_gross = 0;
      }

      if (resetDates) {
        this.data.start_date = "";
        this.data.end_date = "";
      }

      this.data.trial = this.current_lvl.trial;

      if (update) {
        this.updateData();
      }
    });
  }

  public updateData(from: string = "") {
    if (this.typeIsStage) {
      this.data.net_monthly_12 = typeof this.data.net_monthly_12 === "string" ? this._utils.removeDotsFromNumber(this.data.net_monthly_12) : this.data.net_monthly_12;
      this.data.total_daily = Number(this.data.total_daily);
      this.data.gross_monthly_12 = this.data.net_monthly_12;
      this.data.total_daily = this.data.net_monthly_12 / 20;
    } else {
      if (from === "monthly_bonus" || from === "monthly_production_bonus") {
        this.data.total_daily = this.data.total_daily || 0;
        this.data.total_daily = Number(this.data.total_daily.replace(",", "."));
        this.data.total_daily -= this.current_lvl.bonus / 20;
        this.data.total_daily -= this.current_lvl.production_bonus / 12 / 20;
        this.current_lvl.bonus = this.data.bonus;
      }
      if (String(this.data.bonus).length < 1) {
        this.data.bonus = 0;
      }
      if (String(this.data.production_bonus).length < 1) {
        this.data.production_bonus = 0;
      }
      if (String(this.data.ticket_total).length < 1) {
        this.data.ticket_total = 0;
      }
      if (typeof this.data.ticket_total === "string") {
        this.data.ticket_total = this._utils.removeDotsFromNumber(this.data.ticket_total);
      }
      if (typeof this.data.bonus === "string") {
        this.data.bonus = this._utils.removeDotsFromNumber(this.data.bonus);
      }
      if (typeof this.data.production_bonus === "string") {
        this.data.production_bonus = this._utils.removeDotsFromNumber(this.data.production_bonus);
      }
      if (this.data.trial && this.data.trial.length < 1) {
        this.data.trial = this.current_lvl.trial;
      }

      if (from !== "ral") {
        this.data.salary_yearly_gross = Number(this.current_lvl.salary_yearly_gross);
        this.data.trial = Number(this.current_lvl.trial);
        this.data.total_daily = Number(this.current_lvl.total_daily);
        this.data.net_monthly_12 = Number(this.current_lvl.net_monthly_12);
        this.data.net_monthly_13 = Number(this.current_lvl.net_monthly_13);
        this.data.gross_monthly_12 = this.data.salary_yearly_gross / 12;
      } else {
        const ral = this._utils.removeDotsFromNumber(this.data.salary_yearly_gross);

        // decido con che livello fare le proporzioni scegliendo quello più vicino alla ral impostata
        const theshold: number = Number(this.current_lvl.salary_yearly_gross) + (Number(this.next_lvl?.salary_yearly_gross) - Number(this.current_lvl?.salary_yearly_gross)) / 2;
        let lvlToCompare: any = ral > theshold ? this.next_lvl : this.current_lvl;

        if (this.current_lvl.level === "B3") {
          const b3List: any = this.costs
            .filter((c: any) => c.level === "B3" && c.is_apprendistato === Number(this.typeIsApprendistato))
            .sort((a: any, b: any) => {
              a = Number(a.salary_yearly_gross);
              b = Number(b.salary_yearly_gross);
              return a > b ? 1 : a < b ? -1 : 0;
            })
            .map((c: any) => {
              c.salary_yearly_gross = Number(c.salary_yearly_gross);
              return c;
            });

          if (ral >= b3List[b3List.length - 1].salary_yearly_gross - 1) {
            lvlToCompare = b3List[b3List.length - 1];
          } else {
            let currentLvlB3: any;
            let nextLvlB3: any;
            b3List.map((cost: any, i: number) => {
              if (!currentLvlB3 && cost.salary_yearly_gross <= ral && b3List[i + 1].salary_yearly_gross >= ral) {
                currentLvlB3 = cost;
                nextLvlB3 = b3List[i + 1];
              }
            });

            const theSholdB3: any = Number(currentLvlB3.salary_yearly_gross) + (Number(nextLvlB3.salary_yearly_gross) - Number(currentLvlB3.salary_yearly_gross)) / 2;
            lvlToCompare = ral > theSholdB3 ? nextLvlB3 : currentLvlB3;
          }
        }

        const newData: any = {};

        // retribuzione lorda mensile = ral / 12
        newData.gross_monthly_12 = ral / 12;
        // nuova_ral: nuovo_netto_12 = compare_ral: compare_netto_12
        newData.net_monthly_12 = (lvlToCompare.net_monthly_12 * ral) / lvlToCompare?.salary_yearly_gross;
        // nuova_ral: nuovo_netto_13 = compare_ral: compare_netto_13
        newData.net_monthly_13 = (lvlToCompare?.net_monthly_13 * ral) / lvlToCompare?.salary_yearly_gross;
        // nuova_ral: nuovo_totale_giornaliero = compare_ral: compare_totale_giornaliero
        newData.total_daily = (lvlToCompare?.total_daily * ral) / lvlToCompare?.salary_yearly_gross;

        this.data = { ...this.data, ...newData, salary_yearly_gross: ral };
        this.current_lvl = { ...this.current_lvl, ...this.data };
      }

      //  this.data.ticket_value = Number(this.data.ticket_total)
      this.data.total_net_monthly_13 = this.data.net_monthly_13 + this.data.bonus + this.data.production_bonus / 12;
      this.data.total_daily = Number(this.current_lvl.total_daily) + this.data.bonus / 20 + this.data.production_bonus / 12 / 20 + Number(this.data.ticket_value);

      if (this.typeIsApprendistato && this.data.start_date) {
        this.data.end_date = moment(this.data.start_date, "YYYY-MM-DD").add(this.contractDuration, "months").subtract(1, "day").format("YYYY-MM-DD");
      }
    }

    this.addDots();
  }

  private addDots() {
    Object.keys(this.data).map((key: string) => {
      if (this.data[key] && typeof this.data[key] !== "string" && (this.economic_fields.includes(key) || ["bonus", "production_bonus", "ticket_total"].includes(key))) {
        this.data[key] = this._utils.addDotsToNumber(this.data[key]);
      }
    });
  }

  private async showPopupEditLevel(direction: string) {
    const message: any = await this._utils.translate("ALERT.WARNING_CHANGING_CONTRACT_LEVEL_" + direction);
    await this._toastService.info(message);
  }
}
